import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../services/utils.service';

@Injectable({
  providedIn: 'root',
})
export class LoadingInterceptor implements HttpInterceptor {
  protected readonly utils_service = inject(UtilsService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const tractable = request.url.indexOf(environment.laravel_url) != -1;

    if (tractable && request.headers.get('avoid-loading') === null) {
      this.utils_service.enableLoading();
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse): Observable<never> => throwError(() => error)),
      finalize((): void => {
        if (tractable && request.headers.get('avoid-loading') === null) {
          this.utils_service.disableLoading();
        }
      })
    );
  }
}
